<script lang="ts">
  import { tierScore } from '../stores';
  import Answer from './Answer.svelte';
  import { tierQuizData as data } from 'lib/QuizData';
	import { createEventDispatcher } from 'svelte';
  import { __map } from 'lib/utils/Map';
  import { API_END_POINT } from 'lib/utils';
  import Next from './Next.svelte';


	const dispatch = createEventDispatcher();

  let index = 0;
  let selection: any = null;
  let selectionInvalid = false;

  $: ({ id, question, answers, weight } = data[index]);

  function submitAnswer() {
    if (!selection) {
      selectionInvalid = true;
      return;
    }

    tierScore.update((score) => {
      score[selection.category] += weight;
      return score;
    });

    console.log(selection);


    index === data.length - 1 ? dispatch('complete') : index++;

    const selectedAnswerId = selection.id;
    saveToDB(id, selectedAnswerId);

  }


  const saveToDB = (quizId: string, answerId: string) => {
    const mapped = __map.quizDataToDb(quizId, answerId);
    fetch(`${API_END_POINT}/save-option?quizId=${mapped.quizId}&optionId=${mapped.optionId}`, {
      credentials: "include"
    })
    .then((response) => response.text())
    .then((result) => {
      console.log(result);
    });
  }
</script>

<h2><i>{index + 1}</i> {question}</h2>

<div>
  {#each answers as answer (answer.id)}
    <span>
      <Answer on:click={() => selection={...answer}} selected={selection?.id == answer.id}>
        {answer?.body}
      </Answer>
    </span>
  {/each}
</div>

{#if selectionInvalid && !selection}
  <p>
    Please make a selection above
  </p>
{/if}

<Next on:click={() => submitAnswer()}></Next>


<style>
  p {
    color: red;
    margin: 15px 0;
  }
</style>